import PropTypes from 'prop-types';
import { Button, vars } from '@etg/wings';
import { variants } from '@eti/components';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { useHeightContext, useTranslation } from '@eti/providers';
import { useScrollTo } from '@eti/utils';
import { useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import { getBestPriceCharacteristics } from '../../utils/segments';
import SeatMapLegend from './legend/SeatMapLegend';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = mobileCartHeightContext => {
  var _ref;
  return css`
  background-color: ${etiColors.white};
  bottom: ${(_ref = `${mobileCartHeightContext}px`) !== null && _ref !== void 0 ? _ref : '0px'};
  position: sticky;
  width: 100%;
  z-index: 10;
`;
};
const legendWrapperStyles = css`
  position: relative;
`;
const buttonsWrapperStyles = (singleAction, bestPriceCharacteristics) => css`
  display: flex;
  flex-shrink: 0;
  justify-content: ${singleAction ? 'flex-end' : 'space-between'};
  margin: 0 auto;
  max-width: 53rem;
  padding: 15px;
  width: 100%;

  ${bestPriceCharacteristics && `border-top: 1px solid ${vars.colors.divider}`}
`;
const continueButtonStyles = css`
  flex: 1;
  max-width: calc(50% - 8px);

  @media (${mediaQueries.large.up}) {
    flex: initial;
  }
`;
const SeatMapFooter = _ref2 => {
  let {
    active,
    handleBackDrop,
    isFirstSegment,
    legendHeight,
    onSeatConfirmation,
    onSaveAndContinue,
    onToPreviousSegment,
    segments,
    setLegendHeight,
    shouldShowSummary
  } = _ref2;
  const {
    t
  } = useTranslation();
  const legendRef = useRef();
  const {
    mobileCartHeightContext
  } = useHeightContext();
  const [activeSegment] = active;
  const bestPriceCharacteristics = getBestPriceCharacteristics(segments, activeSegment);
  const {
    scrollVertical
  } = useScrollTo();
  const saveAndContinueLabel = t('Product.SeatMap.Button.Continue');
  const scrollToTop = () => scrollVertical('smooth', 0);
  const handleResize = throttle(() => {
    if (legendRef !== null && legendRef !== void 0 && legendRef.current) {
      setLegendHeight(legendRef.current.getBoundingClientRect().height);
    }
  }, 300);
  const handleSaveAndContinue = e => {
    if (!shouldShowSummary) {
      scrollToTop();
      onSaveAndContinue(e);
      return;
    }
    onSeatConfirmation(e);
  };
  const handlePreviousSegment = () => {
    scrollToTop();
    onToPreviousSegment();
  };
  useEffect(() => {
    window.addEventListener('resize', handleResize, true);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
  useEffect(() => {
    if (legendRef !== null && legendRef !== void 0 && legendRef.current) {
      const {
        height: currentLegendHeight
      } = legendRef.current.getBoundingClientRect();
      if (legendHeight !== currentLegendHeight) {
        setLegendHeight(currentLegendHeight);
      }
    }
  }, [legendHeight, mobileCartHeightContext, setLegendHeight]);
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperStyles(mobileCartHeightContext),
    "data-testid": "seatMapFooter",
    children: [bestPriceCharacteristics && !shouldShowSummary && /*#__PURE__*/_jsx("div", {
      className: legendWrapperStyles,
      children: /*#__PURE__*/_jsx(SeatMapLegend, {
        bestPriceCharacteristics: bestPriceCharacteristics,
        handleBackDrop: handleBackDrop,
        legendRef: legendRef
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: buttonsWrapperStyles(isFirstSegment, bestPriceCharacteristics),
      children: [!isFirstSegment && /*#__PURE__*/_jsx(Button, {
        className: continueButtonStyles,
        "data-testid": "navigateBackSeatMap-button",
        onClick: handlePreviousSegment,
        children: t('Button.Text.Back')
      }), /*#__PURE__*/_jsx(Button, {
        className: continueButtonStyles,
        "data-testid": "saveAndContinue-button",
        onClick: handleSaveAndContinue,
        variant: variants.PRIMARY,
        children: saveAndContinueLabel
      })]
    })]
  });
};
SeatMapFooter.propTypes = {
  active: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  handleBackDrop: PropTypes.func,
  isFirstSegment: PropTypes.bool,
  legendHeight: PropTypes.number,
  onSaveAndContinue: PropTypes.func,
  onSeatConfirmation: PropTypes.func,
  onToPreviousSegment: PropTypes.func,
  segments: PropTypes.arrayOf(PropTypes.shape({
    from: PropTypes.shape({
      airport: PropTypes.string,
      city: PropTypes.string
    }),
    to: PropTypes.shape({
      airport: PropTypes.string,
      city: PropTypes.string
    })
  })),
  setLegendHeight: PropTypes.func,
  shouldShowSummary: PropTypes.bool
};
export default SeatMapFooter;
//# sourceMappingURL=SeatMapFooter.js.map